import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LoginDiv } from './LogInComponents';
import { FullFooterLayout } from 'stash/components/app/Layouts';
import { NoAuthNavBar } from 'stash/components/global/NoAuthNavBar';
import { selectIsAuthenticated } from 'stash/selectors/session';
import EmailPasswordLogin from './LogInForm/EmailPasswordLogin';
import { postThirdPartyAuth } from 'stash/actions/api/auth';
import { selectQueryParams } from 'stash/selectors';

// This login page should only ever be accessed by third party services (such as Mint)
const mapStateToProps = (state, ownProps) => {
	const query = selectQueryParams(ownProps);
	return {
		isAuthenticated: selectIsAuthenticated(state),
		query,
	};
};

const mapDispatchToProps = {
	postThirdPartyAuth,
};

export const LogInThirdParty = ({
	postThirdPartyAuth,
	query,
	isAuthenticated,
}) => {
	const handleSubmit = (values) => {
		postThirdPartyAuth(values);
	};

	const getRedirectUrl = () => {
		// Redirect to the ?r param after log in. Be careful of user input here.
		return query.r || '/';
	};
	if (isAuthenticated) {
		return <Redirect to={getRedirectUrl()} />;
	} else {
		return (
			<FullFooterLayout>
				<div>
					<NoAuthNavBar />
					<LoginDiv>
						<EmailPasswordLogin onSubmit={handleSubmit} query={query} />
					</LoginDiv>
				</div>
			</FullFooterLayout>
		);
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(LogInThirdParty);
